<template>
  <div>
    <GSTC :config="config" @state="onState" />
  </div>
</template>

<script>
import GSTC from "vue-gantt-schedule-timeline-calendar";
import locale from "./locale.js";
import plugins from "./plugins";
import modes from "./modes";
import actions from "./actions";
import Line from "./Line";

/*
  4 58 28 7 21 45
*/
let subs = [];

export default {
  name: "gantt",
  components: {
    GSTC
  },
  props: {
    range: {
      type: String,
      default: "dia"
    }
  },
  mounted() {
    const container = this.$el.getElementsByClassName(
      "gantt-schedule-timeline-calendar__chart"
    )[0];
    this.line = new Line(container, this.range);
    const numberOfRows = Object.keys(this.config.list.rows).length;
    const totalHeight = numberOfRows * 42;
    this.config.height = totalHeight + 90;
  },
  updated() {
    //this.line.remove();
  },
  destroyed() {
    this.line.destroy();
  },
  data() {
    return {
      line: {},
      key: 0,
      config: {
        actions: {
          "chart-timeline-items-row-item": actions
        },
        height: 500,
        list: {
          toggle: {
            display: false
          },
          rows: {
            "1": {
              id: "1",
              cod: "B903",
              maq: "PHC513"
            },
            "2": {
              id: "2",
              cod: "G212",
              maq: "JHG123"
            },
            "3": {
              id: "3",
              cod: "J212",
              maq: "INJ098"
            },
            "4": {
              id: "4",
              cod: "F390",
              maq: "TRO933"
            },
            "5": {
              id: "5",
              cod: "G212",
              maq: "JHG123"
            },
            "6": {
              id: "6",
              cod: "J212",
              maq: "INJ098"
            },
            "7": {
              id: "7",
              cod: "G212",
              maq: "JHG123"
            },
            "8": {
              id: "8",
              cod: "J212",
              maq: "IJN098"
            },
            "9": {
              id: "9",
              cod: "G212",
              maq: "JAA994"
            },
            "10": {
              id: "10",
              cod: "J212",
              maq: "INJ098"
            },
            "11": {
              id: "11",
              cod: "G212",
              maq: "JHG123"
            },
            "12": {
              id: "12",
              cod: "J212",
              maq: "INJ098"
            },
            "13": {
              id: "13",
              cod: "G212",
              maq: "JHG123"
            },
            "14": {
              id: "14",
              cod: "aux",
              maq: "INJ098 - aux"
            },
            "15": {
              id: "15",
              cod: "G212",
              maq: "JHG123"
            },
            "16": {
              id: "16",
              cod: "J212",
              maq: "INJ098"
            },
            "17": {
              id: "17",
              cod: "G212",
              maq: "JHG123"
            },
            "18": {
              id: "18",
              cod: "J212",
              maq: "INJ098"
            },
            "19": {
              id: "19",
              cod: "G212",
              maq: "HGJ123"
            },
            "20": {
              id: "20",
              cod: "G212",
              maq: "JHG123"
            }
          },
          columns: {
            data: {
              codCol: {
                id: "codCol",
                data: "cod",
                width: 45,
                header: {
                  content: "Cod"
                }
              },
              maqCol: {
                id: "maqCol",
                data: "maq",
                width: 120,
                header: {
                  content: "Máquina"
                }
              }
            }
          }
        },
        chart: {
          time: {
            from: modes()[this.range].from,
            to: modes()[this.range].to
          },
          items: this.$store.state.orders.sequenced
        },
        locale,
        plugins
      }
    };
  },
  methods: {
    onState(state) {
      this.state = state;
      subs.push(
        state.subscribe("config.chart.items.1", item => {
          console.log("item 1 changed", item);
        })
      );
      subs.push(
        state.subscribe("config.list.rows.1", row => {
          console.log("row 1 changed", row);
        })
      );
    }
  },
  beforeDestroy() {
    subs.forEach(unsub => unsub());
  },
  computed: {
    time() {
      return this.$store.state.ganttChart.moment;
    },
    items() {
      return this.$store.state.orders.sequenced;
    }
  },
  watch: {
    range(newRange) {
      this.config.chart.time = modes()[newRange];
      this.line.updateRange(newRange);
    },
    time(newTime) {
      this.config.chart.time = modes()[this.range];
      this.line.updateTime(newTime);
    }
  }
};
</script>

<style>
.gantt-schedule-timeline-calendar__horizontal-scroll {
  overflow: auto;
}
.moment-line {
  position: absolute;
  top: 5.3rem;
  background: var(--color-red);
  height: calc(100% - 6.5rem);
  width: 0.1rem;
  border-radius: 0.2rem;
}
.gantt-schedule-timeline-calendar__chart {
  position: relative;
}
.gantt-schedule-timeline-calendar__chart-timeline-items-row-item {
  cursor: pointer;
}

.gantt-schedule-timeline-calendar__chart-timeline-items-row-item-label {
  position: relative;
  left: -0.5em;
}
.gantt-schedule-timeline-calendar__chart-timeline-items-row-item-label::first-letter {
  visibility: hidden;
  opacity: 0;
  color: transparent;
}
</style>
